/* Member price cards use the existing discount app, including eligibility and sale rules. */
(() => {
  if (customElements.get('ulg-card-member-price')) return;
  let discountApi = window.RegiosDOPP?.api?.v0;
  const cards = new Set();
  class MemberPriceCard extends HTMLElement {
    connectedCallback() {
      cards.add(this);
      this.renderPrice();
    }
    disconnectedCallback() { cards.delete(this); }
    async renderPrice() {
      if (!discountApi || this.pending || this.rendered) return;
      this.pending = true;
      try {
        const data = JSON.parse(this.querySelector('[data-member-product]').textContent);
        const { priceVaries, ...product } = data;
        const result = await discountApi.calculateDiscountedPrices(product);
        if (!this.isConnected) return;
        // Show a member tile only when the app supplies a lower price.
        if (Number.isFinite(result.salePrice?.amount) &&
            result.salePrice.amount < result.regularPrice.amount) {
          this.querySelector('[data-member-price]').textContent =
            (priceVaries ? 'From ' : '') + result.salePrice.formatted;
          this.hidden = false;
        }
        this.rendered = true;
      } catch (error) {
        // Leave the normal price visible if the discount service is unavailable.
        this.hidden = true;
      } finally { this.pending = false; }
    }
  }
  customElements.define('ulg-card-member-price', MemberPriceCard);
  window.addEventListener('regios-dopp:api-initialized', (event) => {
    discountApi = event.detail.api;
    cards.forEach(card => card.renderPrice());
  });
})();
